import { lazyWithRetry } from "@js/utils";

export const EmbeddedJobsListPage = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "embedded-jobs-list" */ "./embedded-jobs-list-page"
    ),
);
